import getPageTitleTag from '../shared/pageTags/getTitle';

export default function setPageTitle(context, next) {
    const currentPath = context.pathname;
    const { translations } = window.bbcAccount.locals;
    document.title = getPageTitleTag(currentPath, translations);

    next();
}
